/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdActivatePost200Response model module.
 * @module model/CustomersIdActivatePost200Response
 * @version 1.0.0
 */
class CustomersIdActivatePost200Response {
    /**
     * Constructs a new <code>CustomersIdActivatePost200Response</code>.
     * @alias module:model/CustomersIdActivatePost200Response
     */
    constructor() { 
        
        CustomersIdActivatePost200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdActivatePost200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdActivatePost200Response} obj Optional instance to populate.
     * @return {module:model/CustomersIdActivatePost200Response} The populated <code>CustomersIdActivatePost200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdActivatePost200Response();

            if (data.hasOwnProperty('basketRefId')) {
                obj['basketRefId'] = ApiClient.convertToType(data['basketRefId'], 'String');
            }
            if (data.hasOwnProperty('gatewayURL')) {
                obj['gatewayURL'] = ApiClient.convertToType(data['gatewayURL'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdActivatePost200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdActivatePost200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['basketRefId'] && !(typeof data['basketRefId'] === 'string' || data['basketRefId'] instanceof String)) {
            throw new Error("Expected the field `basketRefId` to be a primitive type in the JSON string but got " + data['basketRefId']);
        }
        // ensure the json data is a string
        if (data['gatewayURL'] && !(typeof data['gatewayURL'] === 'string' || data['gatewayURL'] instanceof String)) {
            throw new Error("Expected the field `gatewayURL` to be a primitive type in the JSON string but got " + data['gatewayURL']);
        }

        return true;
    }


}



/**
 * @member {String} basketRefId
 */
CustomersIdActivatePost200Response.prototype['basketRefId'] = undefined;

/**
 * @member {String} gatewayURL
 */
CustomersIdActivatePost200Response.prototype['gatewayURL'] = undefined;






export default CustomersIdActivatePost200Response;

